import ViewSignatureDialog from "./components/ViewSignatureDialog";

const routes = [
  {
    path: "/view-signature",
    name: "view-signature",
    component: ViewSignatureDialog,
    props: route => ({
      entityType: route.query.entityType,
      entityUid: route.query.entityUid
    })
  }
];

export default routes;
